import PropTypes from "prop-types";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "@context/contexts";
import { checkRole } from "@utils/index";

const MaintenanceGate = ({ children }) => {
    const { userData, preferences } = useUser();
    const navigate = useNavigate();
    const location = useLocation();

    const isElevated = checkRole(userData, "moderator");


    useEffect(() => {
        // Skip redirect on login page and maintenance page
        if (location.pathname === "/maintenance/" || location.pathname.startsWith("/login")) {
            return;
        }
        
        // Redirect regular users to /maintenance/ when maintenance is enabled
        if (preferences?.maintenanceMode && !isElevated && userData) {
            navigate("/maintenance/", { replace: true });
        }
    }, [preferences?.maintenanceMode, isElevated, userData, location.pathname, navigate]);

    return children;
};

MaintenanceGate.propTypes = {
    children: PropTypes.node
};

export default MaintenanceGate;
